import { render, staticRenderFns } from "./OrganizationAnnualReports.vue?vue&type=template&id=95f98748&scoped=true&"
import script from "./OrganizationAnnualReports.vue?vue&type=script&lang=js&"
export * from "./OrganizationAnnualReports.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationAnnualReports.vue?vue&type=style&index=0&id=95f98748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f98748",
  null
  
)

export default component.exports